// extracted by mini-css-extract-plugin
module.exports = {"mini__carousel":"styles_mini__carousel__2SkIr"};